import { assetImages } from "constants";
import { t } from "i18next";
import React from "react";

const GallerySuccesModal = ({ afterModalClose, addSuccess }) => {
  return (
    <div
      className="modal fade"
      id="eventGallerySuccessModal"
      tabIndex="-1"
      aria-labelledby="saveInfoLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-body text-center p-5">
            <img
              src={assetImages.congratulationsIcon}
              alt="successfuly"
              className="img-fluid mb-2"
            />
            <h2 className="mb-2">{t("Congratulations")}</h2>
            <p className="fs-lg fw-semibold mb-5">
              {t("You have")} {addSuccess ? t("added") : t("deleted")}{" "}
              {t("images successfully")}.
            </p>
            <div className="action d-flex justify-content-center gap-3">
              <button
                data-bs-dismiss="modal"
                className="btn btn-primary"
                onClick={afterModalClose}
              >
                {t("Close")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GallerySuccesModal;
